<template>
  <v-card
    elevation="0"
    outlined
  >
    <v-card-title>
      <v-icon class="mr-2">
        mdi-filter
      </v-icon>
      Filters
    </v-card-title>
    <v-card-text>
      <v-form
        ref="filterForm"
        v-model="formValid"
      >
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-select
              v-model="filters.abBucketId"
              :items="bucketOptions"
              item-text="name"
              item-value="id"
              label="AB Bucket"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-select
              v-model="filters.abTestId"
              :items="testOptions"
              item-text="name"
              item-value="id"
              label="AB Test"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="filters.dateFrom"
              type="date"
              label="Date From"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="filters.dateTo"
              type="date"
              label="Date To"
              outlined
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            class="d-flex justify-end"
          >
            <v-btn
              outlined
              class="mr-2"
              @click="clearFilters"
            >
              <v-icon left>
                mdi-refresh
              </v-icon>
              Clear
            </v-btn>
            <v-btn
              color="primary"
              :disabled="!formValid"
              @click="applyFilters"
            >
              <v-icon left>
                mdi-magnify
              </v-icon>
              Apply Filters
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'FilterForm',

  props: {
    abTests: {
      type: Array,
      default: () => [],
    },
    abBuckets: {
      type: Array,
      default: () => [],
    },
    initialFilters: {
      type: Object,
      default: () => ({
        abBucketId: null,
        abTestId: null,
        dateFrom: '',
        dateTo: '',
      }),
    },
  },

  emits: ['apply-filters', 'clear-filters', 'update:initial-filters'],

  data() {
    return {
      formValid: false,
      filters: { ...this.initialFilters },
    };
  },

  computed: {
    bucketOptions() {
      return this.abBuckets.map((bucket) => ({
        id: bucket.id,
        name: bucket.bucketName,
      }));
    },

    testOptions() {
      return this.abTests
        .filter((test) => test.bucketId === this.filters.abBucketId)
        .map((test) => ({
          id: test.id,
          name: test.testName,
        }));
    },
  },

  watch: {
    initialFilters: {
      handler(newFilters) {
        this.filters = { ...newFilters };
      },
      deep: true,
    },

    'filters.abBucketId': {
      handler() {
        this.$emit('update:initial-filters', {
          ...this.filters,
          abTestId: null,
        });
      },
    },
  },

  methods: {
    clearFilters() {
      this.filters = {
        abBucketId: null,
        abTestId: null,
        dateFrom: '',
        dateTo: '',
      };
      this.$refs.filterForm.resetValidation();
      this.$emit('clear-filters');
    },

    applyFilters() {
      if (!this.formValid) {
        return;
      }
      this.$emit('apply-filters', { ...this.filters });
    },
  },
};
</script>
